var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{ref:"area",attrs:{"id":"faceGeo"}},[_c('div',{ref:"bg",staticClass:"bg"}),_c('div',{ref:"rect",staticClass:"draw_rect"}),_c('div',{ref:"dots",staticClass:"dots"}),_c('div',{ref:"dot_annotations",staticClass:"dot_annotations"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }